// extracted by mini-css-extract-plugin
module.exports = {"daysLeft":"_ee20aa4"};